// Authorized hours × bill rate: what the prior auths say a period is worth
// if every hour is delivered. Set against what was actually billed, it is the
// utilisation of the authorization — the one question the Projections sheet
// answers that is worth asking every month. Shared by the Overview strip and
// Projections, so retiring Projections is a single move.
import { supabase } from './supabase';

export const SKILLED_BILL_FALLBACK   = 95.36;   // S9123 RN skilled, GAPP fee schedule
export const UNSKILLED_BILL_FALLBACK = 25.52;   // S9122 PCS
export const WEEKS_PER_MONTH = 52 / 12;

const topRate = (rows) => rows.map(r => Number(r.default_charge_rate)).filter(n => n > 0).sort((a, b) => b - a)[0];

/** Skilled and unskilled bill rates from the catalog rows, with fallbacks. */
export const billRatesFromCatalog = (catalog = []) => ({
  skilledBill:   topRate(catalog.filter(c => c.code === 'RN_SKILLED')) || topRate(catalog.filter(c => c.skill_kind === 'skilled')) || SKILLED_BILL_FALLBACK,
  unskilledBill: topRate(catalog.filter(c => c.skill_kind === 'pss')) || UNSKILLED_BILL_FALLBACK,
});

export const loadBillRates = async () => {
  const { data } = await supabase.from('service_catalog')
    .select('code, skill_kind, default_charge_rate').eq('active', true).eq('billable', true);
  return billRatesFromCatalog(data || []);
};

/** A client's authorized hours per week, both lines. */
export const authorizedWeeklyHours = (client) => ({
  skilled:   Number(client?.pa_skilled_hours_week) || 0,
  unskilled: Number(client?.pa_pss_hours_week) || 0,
});

/** Authorized revenue for `weeks` weeks of one client, at the given rates. */
export const authorizedRevenue = (client, rates, weeks) => {
  const h = authorizedWeeklyHours(client);
  return (h.skilled * rates.skilledBill + h.unskilled * rates.unskilledBill) * weeks;
};

/** Whole weeks (fractional) between two YYYY-MM-DD dates, inclusive. */
export const weeksBetween = (startIso, endIso) => {
  const days = (new Date(`${endIso}T12:00:00Z`) - new Date(`${startIso}T12:00:00Z`)) / 86400000 + 1;
  return Math.max(days, 1) / 7;
};
